import { Utils } from 'versafleet-core';

const { Router } = Utils;
const { request, convertDataToParams } = Utils.RequestHelper;

const requestCheck = () => ({ type: 'REQUEST_CHECK' });
const receiveLogoutSuccessful = () => ({ type: 'RECEIVE_LOGOUT_SUCCESSFUL' });
const receiveCheckFailed = () => ({ type: 'RECEIVE_CHECK_FAILED' });
const receiveCheckSuccessful = profile => ({ type: 'RECEIVE_CHECK_SUCCESSFUL', profile });
// eslint-disable-next-line camelcase
const receiveSsoSettingSuccessful = is_enabled => ({ type: 'RECEIVE_CHECK_SSO_ENABLED_SUCCESSFUL', is_enabled });
const receiveSsoLoginSuccessful = url => ({ type: 'RECEIVE_SSO_LOGIN_SUCCESSFUL', url });
const receiveValidateCaptchaSuccessful = () => ({ type: 'RECEIVE_VALIDATE_CAPTCHA_SUCCESSFUL' });
const receiveValidateCaptchaFailed = error => ({ type: 'RECEIVE_VALIDATE_CAPTCHA_FAILED', error });
const resetIsChecked = () => ({ type: 'RESET_IS_CHECKED' });

function login(query) {
  return dispatch => request('/session/login', {
    method: 'POST',
  }, {
    ...query,
  })
    .then(() => {
      dispatch(receiveValidateCaptchaSuccessful());
      Router.transitionTo('/home');
    })
    .catch((error) => {
      dispatch(receiveValidateCaptchaFailed(error));
    });
}

function getSsoSetting(domain) {
  return dispatch => request(`/saml/get_sso_setting${convertDataToParams({ domain })}`, {
    method: 'GET',
  })
    .then((result) => {
      dispatch(receiveSsoSettingSuccessful(result.is_enabled));
      return result.is_enabled;
    });
}

function ssoLogin(domain) {
  return dispatch => request(`/saml/init${convertDataToParams({ domain })}`, {
    method: 'GET',
  })
    .then((result) => {
      dispatch(receiveSsoLoginSuccessful(result.url));
      window.location = result.url;
      return result.url;
    });
}

function logout() {
  return dispatch => request('/session/logout', {
    method: 'DELETE',
  })
    .then((result) => {
      if (result.url) {
        dispatch(receiveLogoutSuccessful(result.url));
        window.location = result.url;
      } else {
        dispatch(receiveLogoutSuccessful('/auth/login'));
        Router.transitionTo('/auth/login');
      }
      dispatch(receiveLogoutSuccessful());
      return result;
    })
    .catch(() => {
      // console.error(err);
    });
}

function check() {
  return (dispatch) => {
    dispatch(requestCheck());
    dispatch(resetIsChecked());
    return request('/profile', {
      method: 'GET',
    })
      .then((result) => {
        dispatch(receiveCheckSuccessful(result.profile));
      })
      .catch((error) => {
        dispatch(receiveCheckFailed());
        throw error;
      });
  };
}

export default {
  getSsoSetting,
  ssoLogin,
  logout,
  check,
  login,
};
